import { render, staticRenderFns } from "./AverageReviewedTrendingGraph.vue?vue&type=template&id=0d3fc216&"
import script from "./AverageReviewedTrendingGraph.vue?vue&type=script&lang=js&"
export * from "./AverageReviewedTrendingGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports